import { styled } from '@mui/material';
import Grid from '@mui/material/Grid';

export const Section = styled(Grid)({
  padding: '1rem',
});

export const TextSection = styled(Section)({
  maxWidth: '80rem',
});

export const ValueDisplay = styled('div', {
  name: 'valueDisplay',
  slot: 'root',
})({
  boxSizing: 'content-box',
  minHeight: '1.75rem',
  display: 'flex',
  alignItems: 'center',
  fontSize: '1.1428571428571428rem',
  fontWeight: 500,
  padding: '8.5px 14px',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
});
